import React, {useState} from 'react';
import {Box, Flex, Text} from "@chakra-ui/layout";
import {Button, FormControl, FormLabel, Image, Input, Link, Textarea, Spinner} from "@chakra-ui/react";
import Profile from "../../../images/header/profile.svg";
import {NavLink} from "react-router-dom";
import {useSelector} from "react-redux";
import {StateType} from "../../../store/store";

function TeacherProfile() {
  const {data, courses: {courses}} = useSelector((state: StateType) => state.rootReducer.teacherReducer)
  const [fullname, setFullname] = useState<string>(data.fullname);
  const [username, setUsername] = useState<string>(data.username);
  const [email, setEmail] = useState<string>(data.email);
  const course = courses.map((course: any) => course.course_name)
  console.log(course)

  function submitChange(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    console.log("changes made and submitted");
  }

  if (data.token === "") {
    return <Flex justifyContent="center" alignItems="center" height="100%" width="100%">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
    </Flex>
  }

  return (
    <Flex m={7} p={7} flexDirection={'column'} bgColor={"white"} borderRadius={"30px"}>
      <Text textTransform={"capitalize"} fontWeight={"bold"} fontSize={"2xl"}>Profile</Text>
      <Box mt={10} mr={{base: 0, lg: 12}}>
        <Image
          boxSize="130px"
          objectFit="cover"
          mr={"12px"}
          src={Profile}
          alt="profile icon"
        />
        <Flex flexDirection={"column"} mt={10}>
          <FormControl id="fullname">
            <FormLabel fontWeight={"semibold"} fontSize={"lg"} textTransform={"capitalize"}>fullname</FormLabel>
            <Input type="text" value={fullname} onChange={(e) => setFullname(e.target.value)} bgColor={"brand.light"}/>
          </FormControl>
          <Flex mt={4} flexDirection={{base: "column", lg: "row"}}>
            <FormControl id="username" mr={{base: 0, lg: 2}}>
              <FormLabel fontWeight={"semibold"} fontSize={"lg"} textTransform={"capitalize"}>username</FormLabel>
              <Input type="text" value={username} onChange={(e) => setUsername(e.target.value)} color={"black"}
                     bgColor={"brand.light"}/>
            </FormControl>
            <FormControl id="email" ml={{base: 0, lg: 2}} mt={{base: 4, lg: 0}}>
              <FormLabel fontWeight={"semibold"} fontSize={"lg"} textTransform={"capitalize"}>Email</FormLabel>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} bgColor={"brand.light"}/>
            </FormControl>
          </Flex>
          <FormControl id="role" mt={4}>
            <FormLabel fontWeight={"semibold"} fontSize={"lg"} textTransform={"capitalize"}>Role</FormLabel>
            <Input type="text" defaultValue={data.role} bgColor={"brand.light"} disabled/>
          </FormControl>
          <FormControl mt={4}>
            <Text fontWeight={"semibold"} fontSize={"lg"} textTransform={"capitalize"}>Subject/Course</Text>
            <Textarea defaultValue={course.map((course) => course)} isDisabled={true}/>
          </FormControl>
        </Flex>
        <Flex justifyContent={"space-between"} mt={7} wrap={"wrap"}>
          <Link as={NavLink} to={"/tutor/change-password"} p={4} bgColor={"brand.orange"}
                color={"brand.gold"} textTransform={"capitalize"} borderRadius={"20px"} fontSize={"md"}
                fontWeight={600}>change password</Link>
          <Button type={"submit"} size="lg" borderRadius={"20px"} textTransform={"capitalize"} fontSize={"md"}
                  bgColor={"brand.darkGreen"} color={"brand.white"} onClick={(e) => submitChange(e)}>save</Button>
        </Flex>
      </Box>
    </Flex>
  );
}

export default TeacherProfile;